import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { AlertController, MenuController, ModalController, NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from "@capacitor/core";
import { ActivatedRoute, NavigationExtras, NavigationStart, NavigationEnd, Router } from '@angular/router';
import { LoginPage } from './pages/login/login.page';
import { SignupPage } from './pages/signup/signup.page';
import { PricingPage } from './pages/pricing/pricing.page';
import { AutocloseOverlaysService } from './services/overlay/autoclose-overlays.service';
import { ApiService } from './services/api/api.service';
import { Events } from './services/events';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Store } from '@ngrx/store';
import { setActiveLocations, setActiveLocationsLastupdate, setAddressType, setAllUserLocation, setAlredyHaveLocation, setLastContactFetch, setLocation, setLocationID, setLocationJobsiteContacts, setLocationaImportantDates, setPreviouslyUsedContacts, setSelectedLocation, setUserLocalDataUpdate } from 'src/store/actions/location';
import { setAuthentication } from 'src/store/actions/authenticate';
import { setNavigationParameter } from 'src/store/actions/navigationVariables';
import { setUser } from 'src/store/actions/user';
import { AuthenticationService } from './services/auth/authentication.service';
import { setIsChangeTrade, setSelectedTrade, setTradeData } from 'src/store/actions/trades';
import { setExpandsPlans, setPunchItem, setPunchItemLocation, setPunchItemsStore, setSelectedLocationPunchItems } from 'src/store/actions/punchItemDetail';
import { setActivityFilters,setActivityScheduledFilters, setJobsiteFilters } from 'src/store/actions/filters';
import { setIsChangeRoom, setRoomData } from 'src/store/actions/room';
import { AddPunchitemSameLocationPage } from './modals/add-punchitem-same-location/add-punchitem-same-location.page';
import { CommonService } from 'src/app/services/common/common.service';
import { ConstantService } from './services/constant/constant.service';
import { setDescriptionData, setImportantDateDescription } from 'src/store/actions/description';
import { setDevelopmentData } from 'src/store/actions/development';
import { setTreeDetail } from 'src/store/actions/treeData';
import { setPlanDetail } from 'src/store/actions/planDetails';
import { setAlertsActiveLocationsLastupdate, setAlertsLocations, setScheduledLocations } from 'src/store/actions/alerts';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { ActionNeededModalPage } from './modals/action-needed-modal/action-needed-modal.page';
import { UtilService } from './services/util/util.service';
import { CoachMarkService } from './services/coach-mark/coach-mark.service';
import { AppSyncService } from './services/appsync/appsync.service';
import { ConfirmationModalPage } from './modals/confirmation-modal/confirmation-modal.page';
import { resetCoachMarks } from 'src/store/actions/coachMark';
import { AnalyticsService } from './services/analytics/analytics.service';
import { CoachMarkConfig } from './components/coach-mark/coach-mark.component';
import { EncouragementService } from './services/encouragement/encouragement.service';
import { PushService } from './services/push/push.service';
import { resetEncouragement } from 'src/store/actions/encouragement';

let html = document.getElementsByTagName("ion-backdrop")[0];
console.log(document.getElementsByTagName("ion-backdrop"));

if (Capacitor.getPlatform() !== "web") {
  Keyboard.addListener('keyboardWillShow', (info: any) => {
    if (document.getElementsByTagName("ion-backdrop")[0]) {
      document.getElementsByTagName("ion-backdrop")[0].style.height = "130%";
    }
  });

  Keyboard.addListener('keyboardWillHide', () => {
    if (document.getElementsByTagName("ion-backdrop")[0]) {
      document.getElementsByTagName("ion-backdrop")[0].style.height = 'auto';
    }
  });
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  public isLogin = false;
  public showCookieBanner = false;
  private initialUrl = '';
  public selectedIndex = 0;
  titls: any;
  private updateSelectedIndexTimeout: any = null;
  public appPages = [
    {
      title: 'Home',
      url: '/home'
    },
    {
      title: 'FAQ',
      url: '/faq'
    },
    {
      title: 'How does it work?',
      url: '/how-does-it-work'
    },
    {
      title: 'Support',
      url: '/support'
    }
  ];
  public appPagesLogin = [
    {
      title: 'Jobsites',
      url: '/tabs/jobsites',
      image: 'assets/icon/menu/home_color.svg',
      image_white: 'assets/icon/menu/home_white.svg'
    },
    {
      // title: 'Activity',
      title: 'Reminders',
      url: '/tabs/activity',
      icon: 'hammer',
      image: 'assets/icon/menu/activity.svg',
      image_white: 'assets/icon/menu/a.svg'
    },
    {
      title: 'Focused chat',
      url: '/tabs/chat',
      image: 'assets/imgs/chat.png',
      image_white: 'assets/imgs/chat.svg'
    },
    {
      title: 'Completed punch',
      url: '/tabs/finished-locations',
      image: 'assets/icon/menu/finished.svg',
      image_white: 'assets/icon/menu/b.svg'
    },
    {
      title: 'Punch list drafts',
      url: '/tabs/punchlist-draft',
      image: 'assets/icon/menu/draft.svg',
      image_white: 'assets/icon/menu/c.svg'
    },
    // {
    //   title: 'FAQ',
    //   url: '/faq',
    //   image: 'assets/icon/menu/faq.svg',
    //   image_white: 'assets/icon/menu/e.svg'
    // },
    // {
    //   title: 'Contacts',
    //   url: '/tabs/jobsites',
    //   image: 'assets/icon/menu/contact.svg',
    //   image_white: 'assets/icon/menu/f.svg'
    // },
  ];
  auth: any;
  userData: any;
  punchItemData:any;
  locationData:any;
  lastContactFetch;

  isRedAlerts = false;
  isOrangeAlerts = false;
  hasNewChats = false;
  unreadCountChecked = false;
  allLocalLocations: any;
  private subscriptionLoaded = false;
  userSubscription: string | null = null;
  // §9.7 — global live account notice (contact method reclaimed) via reusable confirmation modal.
  private accountNoticeSub: any = null;
  private accountNoticeModal: any = null;
  private accountNoticeModalOpen = false;
  private cookieEntryUrl = '';
  private cookieAutoDismissReady = false;
  encouragementConfig: CoachMarkConfig | null = null;


  constructor(
    private platform: Platform,
    private router: Router,
    private menuCtrl: MenuController,
    private modalController: ModalController,
    private navCtrl: NavController,
    private autocloseOverlaysService: AutocloseOverlaysService,
    public apiService: ApiService,
    private events: Events,
    private detectChange: ChangeDetectorRef,
    private authServices: AuthenticationService,
    private route: ActivatedRoute,
    private screenOrientation: ScreenOrientation,
    private store: Store<any>,
    private common: CommonService,
    private zone: NgZone,
    private constant: ConstantService,
    private alertController: AlertController,
    private util: UtilService,
    private coachMarkService: CoachMarkService,
    private appSyncService: AppSyncService,
    private analytics: AnalyticsService,
    private encouragement: EncouragementService,
    private push: PushService,
  ) {
    this.initializeApp();

    this.events.subscribe('alerts', (data: any) => {
      this.store.select<any>('locationData').subscribe(state => this.allLocalLocations = state);

      this.isRedAlerts = false;
      this.isOrangeAlerts = false;

      const alertsActiveLocations = (this.allLocalLocations?.activeLocations || []).filter(element => {
        if (element?.contact_type === 'trade') {
          return !(
            element.totalProgress <= 0 || element.totalProgress === '0' ||
            element.totalProgress == null || element.totalProgress === 'null' ||
            element.totalProgress === undefined || element.totalProgress === 100 ||
            element.totalProgress === '100' || element.status === 'status#complete'
          );
        } else {
          return !(
            element.progress <= 0 || element.progress === '0' ||
            element.progress == null || element.progress === 'null' ||
            element.progress === undefined || element.progress === 100 ||
            element.progress === '100' || element.status === 'status#complete'
          );
        }
      });

      alertsActiveLocations.forEach(element => {
        const filteredAcRedAlerts = element.redAlerts?.filter(alert => {
          if (alert.alertName === 'ScheduleDateClose' || alert.alertName === 'scheduleDateClose') {
            return alert?.contact_type === 'trade';
          }
          if (alert.alertName === 'SupervisorResponse' || alert.alertName === 'supervisorResponse') {
            if (alert.contact_type === 'supervisor') return true;
            if (alert.contact_type === 'jobsite' && alert.jobsite_supervisor === 1) return true;
            return false;
          }
          return true;
        }) || [];

        const filteredAcOrangeAlerts = element.orangeAlerts?.filter(alert => {
          if (alert.alertName === 'ScheduleDateClose' || alert.alertName === 'scheduleDateClose') {
            return alert?.contact_type === 'trade';
          }
          if (alert.alertName === 'TradeComplete' || alert.alertName === 'tradeComplete') {
            if (alert.contact_type === 'supervisor') return true;
            if (alert.contact_type === 'jobsite' && alert.jobsite_supervisor === 1) return true;
            return false;
          }
          return true;
        }) || [];

        if (filteredAcRedAlerts.length > 0) this.isRedAlerts = true;
        if (filteredAcOrangeAlerts.length > 0) this.isOrangeAlerts = true;
      });
        
    });

    // Subscribe to new message received event
    // this.events.subscribe('newMessageReceived', (data: any) => {
    //   console.log('New message received in app component:', data);
    //   this.hasNewChats = true;
    //   this.detectChange.detectChanges();
    // });

    // Subscribe to total chat unread count updated event
    this.events.subscribe('totalChatUnreadCountUpdated', (data: any) => {
      console.log('Total chat unread count updated:', data);
      if (data.totalUnreadCount > 0) {
        this.hasNewChats = true;
      } else {
        this.hasNewChats = false;
      }
      this.detectChange.detectChanges();
    });

    this.encouragement.config$.subscribe((cfg) => {
      this.encouragementConfig = cfg;
    });

  }

  onEncouragementDismissed() {
    this.encouragement.onDismissed();
  }

  checkUnreadChatCount() {
    if(this.unreadCountChecked) {
      return;
    }

    const userId = this.userData?.user?.id || this.userData?.user?.userID;

    if (userId) {
      this.unreadCountChecked = true;

      this.common.callApi(
        this.constant.GET_UNREAD_COUNTS,
        "",
        'GET',
        '',
        false,
        false,
        true
      ).subscribe((results: any) => {
        if (results?.totalUnreadCounts > 0) {
          this.hasNewChats = true;
        } else {
          this.hasNewChats = false;
        }
        console.log('hasNewChats after:', this.hasNewChats);

        this.events.publish('hasNewChatsUpdated', {
          hasNewChats: this.hasNewChats
        });

        this.detectChange.detectChanges();
      }, (err) => {
        console.log("Error getting unread chat count:", err);
        this.hasNewChats = false;
        this.unreadCountChecked = false;

        this.events.publish('hasNewChatsUpdated', {
          hasNewChats: false
        });

        this.detectChange.detectChanges();
      });
    }
  }
  

  ionViewDidEnter() {
    this.platform.ready().then(() => {
      if (Capacitor.getPlatform() !== "web") {
        Keyboard.setScroll({ isDisabled: false });
      }
    });
  }

  // The app restyles Ionic's clearInput button into a "Clear" text label. On the mobile
  // webview the native button's `click` (which performs the clear) fires unreliably — the
  // tap often just blurs/dismisses the keyboard, so the value isn't cleared. `pointerdown`
  // fires reliably BEFORE that blur, so we do the clear here ourselves. `ion-input` is
  // `scoped` (light DOM), so one document-level listener covers every clearInput field.
  setupGlobalClearInputFix() {
    document.addEventListener('pointerdown', (ev: any) => {
      const target = ev.target as HTMLElement;
      const clearBtn = target && target.closest ? target.closest('.input-clear-icon') : null;
      if (!clearBtn) {
        return;
      }
      const ionInput: any = clearBtn.closest('ion-input');
      if (!ionInput) {
        return;
      }
      // Prevent the default so the mobile keyboard-dismiss race can't swallow the clear,
      // then clear the value directly (don't rely on the flaky native click).
      ev.preventDefault();
      this.zone.run(() => {
        const nativeInput: HTMLInputElement = ionInput.querySelector('input');
        ionInput.value = '';
        if (nativeInput) {
          // Clear the underlying <input> too and re-fire its real `input` event. This runs
          // Ionic's own onInput path, syncing the value, the bound form control, and the
          // visible text — and bypasses Ionic's isComposing guard (active mid-typing on
          // mobile) that otherwise left the visible text behind.
          nativeInput.value = '';
          nativeInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        ionInput.dispatchEvent(new CustomEvent('ionChange', { detail: { value: '' }, bubbles: true }));
      });
    }, true);
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      if (Capacitor.getPlatform() !== "web") {
        Keyboard.setScroll({ isDisabled: false })
        StatusBar.setStyle({ style: Style.Dark })
      }

      // Initialize analytics
      this.analytics.init();

      this.setupGlobalClearInputFix();

      this.requestNotificationPermission();
      
      console.log("============== INITIALIZE APP ==============")
      
      const cookieBannerDismissed = localStorage.getItem('cookieBannerDismissed');
      if (!cookieBannerDismissed && Capacitor.getPlatform() === 'web') {
        this.showCookieBanner = true;

        // Let boot redirects finish, then lock the "initial page"
        setTimeout(() => {
          this.cookieEntryUrl = this.router.url.split('?')[0];
          this.cookieAutoDismissReady = true;
        }, 800);
      }


      // Register this phone for push whenever a user is signed in — covers boot with a saved
      // session and every login path, since they all land here. Token refreshes keep the same user.
      let pushUserId = null;
      this.store.select<any>('auth').subscribe(state => {
        this.auth = state;
        const userId = state?.authenticationData?.login ? state.authenticationData.cognitoUser?.attributes?.sub : null;
        if (userId && userId !== pushUserId) this.push.register();
        pushUserId = userId;
      });
      this.store.select<any>('user').subscribe( state => this.userData = state);
      this.store.select<any>('subscriptionData').subscribe(state => this.userSubscription = state.subcripition_type);
      this.store.select<any>('locationData').subscribe(state => this.locationData = state);
      console.log(this.userData, "this.userDatathis.userDatathis.userData");
      
      console.log(Object.keys(this.userData).length === 0, this.userData?.user)
      // if (Object.keys(this.userData).length != 0 && this.userData?.user != null) {
      this.authServices.GetAuthenticationToken().then(async (tokenRes: any) => {
        console.log(tokenRes, "for token");
        // signIn
        if (tokenRes) {
          let accessToken = tokenRes.accessToken.jwtToken;
          let sessionToken = tokenRes.idToken.jwtToken;
          let refreshToken = tokenRes.refreshToken.token;

          // For the Track Event
          const idToken = tokenRes.getIdToken ? tokenRes.getIdToken() : tokenRes.idToken;
          const payload = idToken?.payload || (idToken?.getPayload && idToken.getPayload()) || {};
          const appUserId = payload['custom:userId'] || this.auth?.authenticationData?.cognitoUser?.attributes?.sub;
          const userEmail = payload.email || this.auth?.authenticationData?.cognitoUser?.attributes?.email;

          // set userData and token into Redux
          let uData = {
            token: {
              accessToken: accessToken,
              sessionToken: sessionToken,
              refreshToken: refreshToken
            },
            cognitoUser: {
              attributes: {
                email: userEmail,
                sub: appUserId
              }
            },
            login: true
          }
          await this.store.dispatch(setAuthentication(uData));

          // Session restore = session start (Master Spec §5.1)
          if (appUserId) {
            this.analytics.trackUserLoggedIn(appUserId, 'session_restore', {
              user_id: appUserId,
              email: userEmail,
            });
          }
        }
      }, (err) => {
        console.log(err, "error");
      })

      // Outside the user guard on purpose: with no user it only opens the helper-screen gate,
      // and the login that follows carries the server's onboarding map.
      this.coachMarkService.hydrateFromBackend();
      this.encouragement.hydrateConfig();

      if(this.userData?.user != null && this.userData?.user != undefined) {
        this.readDataFromUserLocalDataTable();
        this.getPreviousContact();
      }
      
      // }

      SplashScreen.hide();
    });

    // App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    //   console.log(" appUrlOpen  appUrlOpen appUrlOpen appUrlOpen appUrlOpen",event);
      
		// 	// this.zone.run(() => {
		// 	// 	const domain = 'easypunchlist.com';

		// 	// 	const pathArray = event.url.split(domain);
		// 	// 	// The pathArray is now like ['https://devdactic.com', '/details/42']

		// 	// 	// Get the last element with pop()
		// 	// 	const appPath = pathArray.pop();
    //   //   console.log(" appPath  appPath appPath appPath appPath",appPath);
		// 	// 	if (appPath) {
		// 	// 		this.router.navigateByUrl(appPath);
		// 	// 	}
		// 	// });

    //   this.zone.run(() => {
    //     try {
    //       const url = new URL(event.url);

    //       // Handle both custom scheme and https
    //       if (url.protocol === 'com.easypunchlist.appdev:' ||
    //         (url.protocol === 'https:' && url.hostname === 'easypunchlist.com')) {

    //         const path = url.pathname + url.search;
    //         console.log('Extracted path:12345', path);

    //         this.router.navigateByUrl(path);

    //         // // Check if user is authenticated before navigating
    //         // if (this.isUserAuthenticated()) {
    //         //   this.router.navigateByUrl(path);
    //         // } else {
    //         //   // Store deeplink for after login
    //         //   this.storeDeeplinkForLater(path);
    //         //   this.router.navigateByUrl('/login');
    //         // }
    //       } else {
    //         console.log('Unsupported URL scheme:', url.protocol);
    //       }
    //     } catch (error) {
    //       console.error('Deeplink parsing error:', error);
    //       // Fallback to original method for backward compatibility
    //       const domain = 'easypunchlist.com';
    //       const pathArray = event.url.split(domain);
    //       const appPath = pathArray.pop();
    //       if (appPath) {
    //         this.router.navigateByUrl(appPath);
    //       }
    //     }
    //   });
    // });

    // below is today
    // App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    //   console.log("Deeplink received:", event.url);
    //   console.log(event,"event event event event");
      
    //   this.zone.run(() => {
    //     let path = '';
        
    //     // Handle custom scheme URLs
    //     if (event.url.startsWith('com.easypunchlist.appdev://')) {
    //       path = event.url.replace('com.easypunchlist.appdev://', '/');
    //       path = path.replace(/\/+$/, '');
    //       console.log('Custom scheme - Extracted path:', path);
    //     }
    //     // Handle HTTPS URLs
    //     else if (event.url.includes('easypunchlist.com') || event.url.includes('dev.easypunchlist.com')) {
    //       // Determine which domain was used
    //       let domain = 'easypunchlist.com';
    //       if (event.url.includes('dev.easypunchlist.com')) {
    //         domain = event.url.includes('www.dev.easypunchlist.com') ? 'www.dev.easypunchlist.com' : 'dev.easypunchlist.com';
    //       } else if (event.url.includes('www.easypunchlist.com')) {
    //         domain = 'www.easypunchlist.com';
    //       }
    //       const pathArray = event.url.split(domain);
    //       path = pathArray.pop() || '';
    //       console.log('HTTPS - Extracted path:', path);
    //     }
                
    //     // Normalize path: remove trailing slashes to prevent routing errors
    //     if (path) {
    //       path = path.replace(/\/+$/, '');
    //     }
    //     // // Fix: Add /tabs/ prefix for jobsites routes
    //     // if (path.startsWith('/jobsites/')) {
    //     //   path = '/tabs' + path;
    //     //   console.log('Fixed path with /tabs/ prefix:', path);
    //     // }
        
    //     console.log('Final path to navigate:123', path);
    //     // const token = this.extractAuthToken(path);
    //     // this.validateDeeplinkUserWithContactInfo(token).then(validationResult => {
    //     //   console.log("validationResult validationResult validationResult",validationResult);
          
    //     //   // if (!validationResult.isValid) {
    //     //   //   this.storeDeeplinkForLater(path);
    //     //   //   if (validationResult.contactMethod && validationResult.contactValue) {
    //     //   //     localStorage.setItem('deeplinkModalData', JSON.stringify({
    //     //   //       contactMethod: validationResult.contactMethod,
    //     //   //       contactValue: validationResult.contactValue,
    //     //   //       showModal: true
    //     //   //     }));
    //     //   //   }

    //     //   //   this.router.navigateByUrl('/home').then(() => {
    //     //   //     if (validationResult.contactMethod && validationResult.contactValue) {
    //     //   //       setTimeout(() => {
    //     //   //         this.showActionNeededModal(validationResult.contactMethod!, validationResult.contactValue!);
    //     //   //       }, 300);
    //     //   //     }
    //     //   //   });

    //     //   //   return; // stop navigation to deeplink
    //     //   // } else {
    //     //   //   const cleanPath = path.split('?')[0] + (path.split('?')[1]?.replace(/auth=[^&]*&?/, '').replace(/&$/, '') || '');
    //     //   //   this.router.navigateByUrl(cleanPath);
    //     //   // }
    //     // });
        
    //     // below is new code of AuthenticationService
    //     if (path) {
    //       const token = this.extractAuthToken(path);

    //       if (this.isUserAuthenticated()) {
    //         if (token) {
    //           this.validateDeeplinkUserWithContactInfo(token).then(validationResult => {
    //             if (!validationResult.isValid) {
    //               this.storeDeeplinkForLater(path);
    //               if (validationResult.contactMethod && validationResult.contactValue) {
    //                 localStorage.setItem('deeplinkModalData', JSON.stringify({
    //                   contactMethod: validationResult.contactMethod,
    //                   contactValue: validationResult.contactValue,
    //                   showModal: true
    //                 }));
    //               }

    //               this.router.navigateByUrl('/home').then(() => {
    //                 if (validationResult.contactMethod && validationResult.contactValue) {
    //                   setTimeout(() => {
    //                     this.showActionNeededModal(validationResult.contactMethod!, validationResult.contactValue!);
    //                   }, 300);
    //                 }
    //               });

    //               return; // stop navigation to deeplink
    //             } else {
    //               const cleanPath = path.split('?')[0] + (path.split('?')[1]?.replace(/auth=[^&]*&?/, '').replace(/&$/, '') || '');
    //               this.router.navigateByUrl(cleanPath);
    //             }
    //           });
    //         } else {
    //           this.router.navigateByUrl(path);
    //         }
    //       } else {
    //         this.storeDeeplinkForLater(path);
    //         this.router.navigateByUrl('/home');
    //       }
    //     }

    //     // if (path) {
    //     //   // Check if user is authenticated
    //     //   console.log("this.isUserAuthenticated() this.isUserAuthenticated() this.isUserAuthenticated()",this.isUserAuthenticated());
          
    //     //   if (this.isUserAuthenticated()) {
    //     //     // User is logged in - navigate directly (native app)
    //     //     console.log('Native - User authenticated - navigating directly to deeplink');
    //     //     this.router.navigateByUrl(path);
    //     //   } else {
    //     //     // User not logged in - store deeplink and redirect to login
    //     //     console.log('Native - User not authenticated - storing deeplink and redirecting to login',path);
    //     //     this.storeDeeplinkForLater(path);
    //     //     this.router.navigateByUrl('/home');
    //     //   }
    //     // }

    //     // if (path) {
    //     //   this.router.navigateByUrl(path);
    //     // } else {
    //     //   console.log('No valid path found in URL:', event.url);
    //     // }
    //   });
    // });

    // Shared by deeplinks and tapped push notifications (which carry the same deeplink URL).
    const openAppUrl = (event: URLOpenListenerEvent) => {
      this.zone.run(async () => {
        let path = '';

        if (event.url.startsWith('com.easypunchlist.appdev://')) {
          path = event.url.replace('com.easypunchlist.appdev://', '/');
        } else if (event.url.includes('easypunchlist.com') || event.url.includes('dev.easypunchlist.com')) {
          let domain = 'easypunchlist.com';
          if (event.url.includes('dev.easypunchlist.com')) {
            domain = event.url.includes('www.dev.easypunchlist.com') ? 'www.dev.easypunchlist.com' : 'dev.easypunchlist.com';
          } else if (event.url.includes('www.easypunchlist.com')) {
            domain = 'www.easypunchlist.com';
          }
          const pathArray = event.url.split(domain);
          path = pathArray.pop() || '';
        }

        if (path) {
          path = path.replace(/\/+$/, '');
          if (this.isUserAuthenticated()) {
            const token = this.extractAuthToken(path);

            if (token) {
              const validationResult = await this.validateDeeplinkUserWithContactInfo(token);
              console.log("validationResult validationResult validationResult", validationResult);

              if (!validationResult.isValid) {
                this.storeDeeplinkForLater(path);

                if (validationResult.contactMethod && validationResult.contactValue) {
                  localStorage.setItem('deeplinkModalData', JSON.stringify({
                    contactMethod: validationResult.contactMethod,
                    contactValue: validationResult.contactValue,
                    showModal: true
                  }));
                }

                await this.router.navigateByUrl('/home');

                if (validationResult.contactMethod && validationResult.contactValue) { // show action-needed-modal if registerUser is false
                  setTimeout(() => {
                    this.showActionNeededModal(validationResult.contactMethod!, validationResult.contactValue!);
                  }, 300);
                }
                return; // stop further navigation
              }
              console.log(path, "path pathh");

              const pathname = path.split('?')[0].replace(/\/+$/, '');
              const queryString = path.split('?')[1]?.replace(/auth=[^&]*&?/, '').replace(/&$/, '') || '';
              const cleanPath = queryString ? `${pathname}?${queryString}` : pathname;
              console.log("cleanPath cleanPath cleanPath", cleanPath);

              await this.router.navigateByUrl(cleanPath);
            } else {
              await this.router.navigateByUrl(path);
            }
          } else {
            this.storeDeeplinkForLater(path);
            await this.router.navigateByUrl('/home');
            setTimeout(() => {
              this.openLoginModal('deeplink', path);
            }, 300);
          }
        }
      });
    };
    App.addListener('appUrlOpen', openAppUrl);
    this.push.init((url) => openAppUrl({ url }));

    // Handle web/desktop deeplinks
    if (Capacitor.getPlatform() === "web") {
      console.log("--------------------------------------------------------------------");

      // Check initial URL on page load
      setTimeout(async () => {
        const currentUrl = window.location.href;
        // let authToken = currentUrl.searchParams.get("auth");
        let path = '';

        // Handle HTTPS URLs with easypunchlist.com domain
        if (currentUrl.includes('easypunchlist.com') || currentUrl.includes('dev.easypunchlist.com')) {
          let domain = 'easypunchlist.com';
          if (currentUrl.includes('dev.easypunchlist.com')) {
            domain = currentUrl.includes('www.dev.easypunchlist.com') ? 'www.dev.easypunchlist.com' : 'dev.easypunchlist.com';
          } else if (currentUrl.includes('www.easypunchlist.com')) {
            domain = 'www.easypunchlist.com';
          }
          const pathArray = currentUrl.split(domain);
          path = pathArray.pop() || '';
          // Normalize path: remove trailing slashes to prevent routing errors
          if (path) {
            path = path.replace(/\/+$/, '');
          }
          // Only process if it's not a public route (same as localhost)
          if (path === '/' || path === '/home' || path === '/login' || path === '/signup' || path.startsWith('/routing') || path.startsWith('/terms-of-service') || path.startsWith('/privacy-policy') || path.startsWith('/sms-consent') || path.startsWith('/faq') || path.startsWith('/how-does-it-work') || path.startsWith('/unsubscribe')) {
            path = ''; // Ignore public routes
          } else {
            console.log('Web - Extracted path:', path);
          }

        }
        // Handle localhost or local development URLs
        else if (currentUrl.includes(window.location.origin)) {
          const url = new URL(currentUrl);
          path = url.pathname + url.search;
          // Normalize path: remove trailing slashes to prevent routing errors (but keep query params)
          if (path && path !== '/') {
            // Only remove trailing slashes from pathname part, not from query string
            const pathParts = path.split('?');
            pathParts[0] = pathParts[0].replace(/\/+$/, '');
            path = pathParts.join('?');
          }
          // Only process if it's not a public route
          if (path === '/' || path === '/home' || path === '/login' || path === '/signup' || path.startsWith('/routing') || path.startsWith('/terms-of-service') || path.startsWith('/privacy-policy') || path.startsWith('/sms-consent') || path.startsWith('/faq') || path.startsWith('/how-does-it-work') || path.startsWith('/unsubscribe')) {
            path = ''; // Ignore public routes
          } else {
            console.log('Web - Extracted path:', path);
          }
        }

        if (path) {
          // Check if user is authenticated
          let token = this.extractAuthToken(path);
          console.log('Web - Extracted token:', token);
          if (this.isUserAuthenticated()) {
            // User is authenticated
            // Detect if mobile or desktop
            const platform = this.platform.platforms();
            const isMobile = platform.includes('mobile');
            const isDesktop = platform.includes('desktop');
          
            console.log('Web - User authenticated - Platform:', platform, 'isMobile:', isMobile, 'isDesktop:', isDesktop);
          
            if (isMobile) {
              // Mobile: Even if authenticated, redirect to app-download page (app not installed)
              console.log('Web - Mobile detected (authenticated) - redirecting to app-download page');
              this.storeDeeplinkForLater(path);
              this.router.navigate(['/app-download'], {
                queryParams: {
                  deepLink: encodeURIComponent(path)
                }
              });
            } else {
              // Desktop: Validate and show modal if needed (same as native app)
              console.log('Web - Desktop detected (authenticated) - validating deeplink');
              
              const token = this.extractAuthToken(path);
              
              if (token) {
                // Use validateDeeplinkUserWithContactInfo (same as native) to get contact info
                const validationResult = await this.validateDeeplinkUserWithContactInfo(token);
                console.log('Desktop - Validation result:', validationResult);
                
                if (!validationResult.isValid) {
                  // User IDs don't match - show action-needed-modal
                  this.storeDeeplinkForLater(path);
                  
                  if (validationResult.contactMethod && validationResult.contactValue) {
                    localStorage.setItem('deeplinkModalData', JSON.stringify({
                      contactMethod: validationResult.contactMethod,
                      contactValue: validationResult.contactValue,
                      showModal: true
                    }));
                  }
                  
                  await this.router.navigateByUrl('/home');
                  
                  if (validationResult.contactMethod && validationResult.contactValue) { // show action-needed-modal if registerUser is false
                    setTimeout(() => {
                      this.showActionNeededModal(validationResult.contactMethod!, validationResult.contactValue!);
                    }, 300);
                  }
                  return; // stop further navigation
                }
                
                // User IDs match - navigate to clean path
                const pathname = path.split('?')[0].replace(/\/+$/, '');
                const queryString = path.split('?')[1]?.replace(/auth=[^&]*&?/, '').replace(/&$/, '') || '';
                const cleanPath = queryString ? `${pathname}?${queryString}` : pathname;
                console.log("Desktop - Clean path:", cleanPath);
                
                await this.router.navigateByUrl(cleanPath);
              } else {
                // No token - just navigate to path
                await this.router.navigateByUrl(path);
              }
            }
          } else {
            // User not logged in
            // Detect if mobile or desktop
            const platform = this.platform.platforms();
            const isMobile = platform.includes('mobile');
            const isDesktop = platform.includes('desktop');

            console.log('Web - User not authenticated - Platform:', platform, 'isMobile:', isMobile, 'isDesktop:', isDesktop);

            if (isMobile) {
              // Mobile: Store deeplink and redirect to download page
              console.log('Web - Mobile detected - redirecting to download page');
              this.storeDeeplinkForLater(path);
              this.router.navigate(['/app-download'], {
                queryParams: {
                  deepLink: encodeURIComponent(path)
                }
              });
            } else {
              // Desktop: Store deeplink and show web view (redirect to home for login)
              console.log('Web - Desktop detected - storing deeplink and redirecting to home',path);
              this.storeDeeplinkForLater(path);
              this.router.navigateByUrl('/home');
              setTimeout(() => {
                this.openLoginModal('deeplink', path);
              }, 300);
            }
          }
        }
      }, 100);
    }
  }

  private extractAuthToken(path: string): string | null {
    try {
      const url = new URL("https://dummy" + path);
      return url.searchParams.get("auth");
    } catch (e) {
      return null;
    }
  }

  private validateDeeplinkUser(authToken: string): Promise<boolean> {
    console.log('=== Starting Deeplink User Validation ===');
    console.log('Auth Token:', authToken);
    
    // Get current logged-in user ID
    const currentUserId = this.userData?.user?.id || this.userData?.user?.userID;
    console.log('Current Logged-in User ID:', currentUserId);
    
    if (!currentUserId) {
      console.log('❌ No logged-in user ID found');
      return Promise.resolve(false);
    }
  
    // Call API to decrypt the token
    console.log('Calling decrypt API...');
    return this.common.callApi(
      this.constant.DECRYPT_TOKEN,
      { token: authToken },
      'POST',
      '',
      false,
      false,
      true
    ).toPromise().then((results: any) => {
      console.log('Decrypt API Response:', results);
      
      if (!results || !results.data) {
        console.log('❌ Invalid response from decrypt API');
        return false;
      }
  
      console.log('Decrypted Data:', results.data);
      
      // Extract user ID from decrypted data
      // Adjust this based on your decrypted data structure
      const deeplinkUserId = results.data.userId || results.data.user_id || results.data.id;
      
      console.log('Deeplink User ID (from decrypted token):', deeplinkUserId);
      
      if (!deeplinkUserId) {
        console.log('❌ No user ID found in decrypted token');
        return false;
      }
  
      // Compare user IDs
      const userMatches = deeplinkUserId === currentUserId;
      
      console.log('=== Comparison Result ===');
      console.log('Deeplink User ID:', deeplinkUserId);
      console.log('Current User ID:', currentUserId);
      console.log('User IDs Match:', userMatches ? '✅ YES' : '❌ NO');
      console.log('=== End Validation ===');
      
      return userMatches;
    }).catch((err) => {
      console.error('❌ Error validating deeplink user:', err);
      return false;
    });
  }

  private async validateDeeplinkUserWithContactInfo(authToken: string) {
    console.log('=== Starting Deeplink User Validation ===');
    console.log('Auth Token:', authToken);
    this.store.select<any>('user').subscribe(state => this.userData = state);
      console.log(this.userData, "this.userDatathis.userDatathis.userData");
    // Get current logged-in user ID
    const currentUserId = this.userData?.user?.id || this.userData?.user?.userID;
    console.log('Current Logged-in User ID:', currentUserId);
    
    if (!currentUserId) {
      console.log('❌ No logged-in user ID found');
      return { isValid: false, contactMethod: null, contactValue: null, registerUser: false };
    }
  
    // Call API to decrypt the token
    console.log('Calling decrypt API...');
    const decryptedData = await this.common.callApi(
      this.constant.DECRYPT_TOKEN,
      { token: authToken },
      'POST',
      '',
      false,
      false,
      true
    ).toPromise();

    if (!decryptedData || !decryptedData.data) {
      console.log('❌ Invalid response from decrypt API');
      return { isValid: false, contactMethod: null, contactValue: null, registerUser: false };
    }

    console.log('Decrypted Data:', decryptedData.data);
    
    // Extract user ID from decrypted data
    // Adjust this based on your decrypted data structure
    const deeplinkUserId = decryptedData.data.userId || decryptedData.data.user_id || decryptedData.data.id;
    // Extract registerUser from decrypted data
    const registerUser = decryptedData.data.registerUser;
    console.log('Deeplink User ID (from decrypted token):', deeplinkUserId);
    
    if (!deeplinkUserId) {
      console.log('❌ No user ID found in decrypted token');
      return { isValid: false, contactMethod: null, contactValue: null, registerUser: registerUser || false };
    }
  
    // Compare user IDs
    const userMatches = deeplinkUserId === currentUserId;
    
    console.log('=== Comparison Result ===');
    console.log('Deeplink User ID:', deeplinkUserId);
    console.log('Current User ID:', currentUserId);
    console.log('User IDs Match:', userMatches ? '✅ YES' : '❌ NO');
    console.log('=== End Validation ===');

    if (!userMatches) {
      // If user IDs don't match, determine the contact method and value
      const contactMethod = 'deeplink';
      const contactValue = authToken; // Store the token itself
      // Store decrypted data only when users don't match (when modals are needed)
      localStorage.setItem('deeplinkDecryptedData', JSON.stringify(decryptedData.data));
      // return { isValid: false, contactMethod: contactMethod, contactValue: contactValue, registerUser: registerUser || false };
      return { isValid: false, contactMethod: decryptedData.data.method, contactValue: decryptedData.data.contactValue, registerUser: registerUser || false };
    }
    // If users match, clean up any existing stored data
    localStorage.removeItem('deeplinkDecryptedData');
    return { isValid: true, contactMethod: decryptedData.data.method, contactValue: decryptedData.data.contactValue, registerUser: registerUser || false };
  }

  private async showActionNeededModal(contactMethod: string, contactValue: string) {
    const modal = await this.modalController.create({
      component: ActionNeededModalPage,
      cssClass: 'modal_all',
      backdropDismiss: false,
      componentProps: {
        contactMethod: contactMethod,
        contactValue: contactValue
      }
    });
    await modal.present();
  }

  // Check if user is authenticated
  private isUserAuthenticated(): boolean {
    // Check if user has valid token
    const token = this.apiService.getToken();
    return !!token;
  }

  // Add this new method to decrypt token and store data before opening login modal
  private async decryptAndStoreDeeplinkData(path: string): Promise<any | null> {
    try {
      const token = this.extractAuthToken(path);
      if (!token) return null;

      const decryptedResp = await this.common.callApi(
        this.constant.DECRYPT_TOKEN,
        { token },
        'POST',
        '',
        false,
        false,
        true
      ).toPromise();

      const decrypted = decryptedResp?.data ?? null;

      if (decrypted) {
        localStorage.setItem('deeplinkDecryptedData', JSON.stringify(decrypted));
      }

      return decrypted;
    } catch (error) {
      console.error('Error decrypting token before login modal:', error);
      return null;
    }
  }

  // Pass decrypted data through componentProps
  private async openLoginModal(source: string, path?: string): Promise<void> {
    const deeplinkDecryptedData = source === 'deeplink' && path ? await this.decryptAndStoreDeeplinkData(path) : null;
    console.log(deeplinkDecryptedData.registerUser,"deeplinkDecryptedData deeplinkDecryptedData deeplinkDecryptedData deeplinkDecryptedData", deeplinkDecryptedData);
    console.log(source,"(!deeplinkDecryptedData || deeplinkDecryptedData.registerUser != true)",(deeplinkDecryptedData && deeplinkDecryptedData.registerUser == true));
    
    // Only open the login modal for deeplink when registerUser is explicitly true
    if (source === 'deeplink' && (deeplinkDecryptedData && deeplinkDecryptedData.registerUser == true)) {
      console.log('Skipping login modal: registerUser is false or missing.');
      return;
    }

    const modal = await this.modalController.create({
      component: LoginPage,
      cssClass: 'modal_login',
      backdropDismiss: false,
      componentProps: {
        source,
        deeplinkDecryptedData, // ✅ returned data here
      },
    });

    await modal.present();
  }

  private storeDeeplinkForLater(path: string): void {
    // Normalize path: remove trailing slashes before query string
    if (!path) return;
    const [pathname, queryString] = path.split('?');
    const normalizedPathname = pathname.replace(/\/+$/, '');
    const normalizedPath = queryString ? `${normalizedPathname}?${queryString}` : normalizedPathname;
    localStorage.setItem('pendingDeeplink', normalizedPath);
    console.log('Stored deeplink for later:', normalizedPath);
  }

  public getPendingDeeplink(): string | null {
    const deeplink = localStorage.getItem('pendingDeeplink');
    if (deeplink) {
      localStorage.removeItem('pendingDeeplink');
      // Normalize path: remove trailing slashes before query string
      const [pathname, queryString] = deeplink.split('?');
      const normalizedPathname = pathname.replace(/\/+$/, '');
      const normalizedDeeplink = queryString ? `${normalizedPathname}?${queryString}` : normalizedPathname;
      console.log('Retrieved pending deeplink:', normalizedDeeplink);
      return normalizedDeeplink;
    }
    return null;
  }

  updateSelectedIndexFromRoute() {
    // Debounce to prevent multiple rapid calls
    if (this.updateSelectedIndexTimeout) {
      clearTimeout(this.updateSelectedIndexTimeout);
    }
    
    this.updateSelectedIndexTimeout = setTimeout(() => {
      this._updateSelectedIndexFromRoute();
      this.updateSelectedIndexTimeout = null;
    }, 50);
  }

  private _updateSelectedIndexFromRoute() {
    if (!this.isLogin) {
      // For non-logged in users, check appPages
      const currentUrl = this.router.url.split('?')[0].toLowerCase(); // Remove query params and normalize
      const foundIndex = this.appPages.findIndex(page => {
        const pageUrl = page.url.split('?')[0].toLowerCase(); // Remove query params and normalize
        return currentUrl === pageUrl || currentUrl.startsWith(pageUrl + '/');
      });
      if (foundIndex !== -1) {
        this.selectedIndex = foundIndex;
      }
    } else {
      // For logged in users, check appPagesLogin first
      let currentUrl = this.router.url.split('?')[0]; // Remove query params
      const queryParams = this.router.url.includes('?') ? this.router.url.split('?')[1] : '';
      
      // Normalize current URL - ensure it starts with /
      if (!currentUrl.startsWith('/')) {
        currentUrl = '/' + currentUrl;
      }
      const currentUrlLower = currentUrl.toLowerCase();
      
      // Check for bottom menu items first (FAQ, Contacts, Terms, Privacy)
      // These use titls instead of selectedIndex
      if (currentUrlLower === '/faq' || currentUrlLower.startsWith('/faq/')) {
        this.selectedIndex = 7;
        this.titls = 'FAQ';
        this.detectChange.detectChanges();
        return;
      }
      
      // Check for Contacts page - /tabs/profile-new with fromWhere=webContacts
      if (currentUrlLower === '/tabs/profile-new' || currentUrlLower.startsWith('/tabs/profile-new/')) {
        // Check if query params contain fromWhere=webContacts
        // Handle both encoded and non-encoded query params
        const fullUrl = this.router.url;
        if (fullUrl.includes('fromWhere=webContacts') || fullUrl.includes('fromWhere%3DwebContacts')) {
          this.selectedIndex = 7;
          this.titls = 'Contacts';
          this.detectChange.detectChanges();
          return;
        }
      }
      
      // Check for Terms & Conditions (if it has a route)
      // Note: Terms might not have a dedicated route, but we check anyway
      if (currentUrlLower.includes('/terms') || currentUrlLower.includes('terms-and-conditions')) {
        this.selectedIndex = 7;
        this.titls = 'terms';
        this.detectChange.detectChanges();
        return;
      }
      
      // Check for Privacy Policy (if it has a route)
      // Note: Privacy might not have a dedicated route, but we check anyway
      if (currentUrlLower.includes('/privacy') || currentUrlLower.includes('privacy-policy')) {
        this.selectedIndex = 7;
        this.titls = 'privacy';
        this.detectChange.detectChanges();
        return;
      }
      
      // If none of the bottom menu items match, check appPagesLogin
      const foundIndex = this.appPagesLogin.findIndex(page => {
        let pageUrl = page.url.split('?')[0]; // Remove query params
        // Normalize URLs - ensure leading slash
        if (!pageUrl.startsWith('/')) {
          pageUrl = '/' + pageUrl;
        }
        pageUrl = pageUrl.toLowerCase();
        // Match exact URL or if current URL starts with the page URL
        // Also handle cases where currentUrl might be a child route
        return currentUrlLower === pageUrl || currentUrlLower.startsWith(pageUrl + '/');
      });
      if (foundIndex !== -1) {
        this.selectedIndex = foundIndex;
        this.titls = '';
      } else {
        // If no match found, reset titls to ensure bottom menu items are not highlighted
        this.titls = '';
      }
    }
    this.detectChange.detectChanges();
  }

  // §9.7 — start the global live account-notice subscription (any page).
  private startAccountNoticeSubscription() {
    const userId = this.userData?.user?.id || this.userData?.user?.userID;
    if (!userId) return;
    // Durable layer: show anything already stored on the user (from the last user-detail fetch).
    const stored = (this.userData?.user?.notices || [])[0] || null;
    if (stored) this.presentAccountNoticeModal(stored);
    // Live layer: push arrives instantly while the app is open, on any page.
    this.stopAccountNoticeSubscription();
    this.accountNoticeSub = this.appSyncService.subscribeToAccountNotice(userId).subscribe((notice: any) => {
      this.zone.run(() => {
        // Keep Redux in sync so it survives navigation/reload (dedupe by sk).
        if (this.userData?.user) {
          const notices = [notice, ...((this.userData.user.notices || []).filter((n: any) => n?.sk !== notice?.sk))];
          this.store.dispatch(setUser({ ...this.userData.user, notices }));
        }
        this.presentAccountNoticeModal(notice);
      });
    }, (err: any) => console.error('account notice subscription error', err));
  }

  private stopAccountNoticeSubscription() {
    if (this.accountNoticeSub && this.accountNoticeSub.unsubscribe) {
      this.accountNoticeSub.unsubscribe();
    }
    this.accountNoticeSub = null;
  }

  // §9.7 — show the reusable confirmation modal (orange primary) for one notice.
  // One modal at a time; queued notices show after the current is dismissed.
  private async presentAccountNoticeModal(notice: any) {
    if (!notice || this.accountNoticeModalOpen) return;
    this.accountNoticeModalOpen = true;
    const modal = await this.modalController.create({
      component: ConfirmationModalPage,
      cssClass: 'modal_all',
      backdropDismiss: false,
      componentProps: {
        title: 'Contact method removed',
        messages: [
          `${notice.contactValue} was verified by another Easy Punch List user and is no longer connected to your account.`,
          'Future punch sent directly to that contact method will no longer route to you. Existing punch and jobsite access assigned to you were not changed.'
        ],
        cancelText: 'Dismiss',
        confirmText: 'Review contacts',
        type: 'neutral',
      },
    });
    this.accountNoticeModal = modal;
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.accountNoticeModal = null;
    this.accountNoticeModalOpen = false;
    this.consumeAccountNotice(notice);              // delete the row + drop from Redux
    if (data?.confirm) this.reviewConnectedContacts();
    // Show the next queued notice, if any.
    const next = (this.userData?.user?.notices || [])[0];
    if (next) this.presentAccountNoticeModal(next);
  }

  // §9.7 — consume a notice: drop from Redux + delete the row server-side (won't return next load).
  private consumeAccountNotice(notice: any) {
    const sk = notice?.sk;
    const userId = this.userData?.user?.id || this.userData?.user?.userID;
    const remaining = (this.userData?.user?.notices || []).filter((n: any) => n?.sk !== sk);
    if (this.userData?.user) {
      this.store.dispatch(setUser({ ...this.userData.user, notices: remaining }));
    }
    if (!userId || !sk) return;
    this.common.callApi(this.constant.DISMISS_NOTICE, { sk }, 'POST', '', false, false, true)
      .subscribe(() => { }, () => { });
  }

  // §9.7 — close any open notice modal (e.g. on logout).
  private dismissAccountNoticeModal() {
    if (this.accountNoticeModal) {
      this.accountNoticeModal.dismiss();
      this.accountNoticeModal = null;
    }
    this.accountNoticeModalOpen = false;
  }

  // §9.7 — CTA target: Connect Existing Punch Lists screen.
  reviewConnectedContacts() {
    this.router.navigate(['/signup-punchlist-email'], { queryParams: { fromWhich: 'accountNotice' } });
  }

  ngOnDestroy() {
    this.stopAccountNoticeSubscription();
  }

  ngOnInit() {
    this.events.subscribe("profileClicked", (data: any) => {
      this.selectedIndex = 10;
    });

    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
    
    // Subscribe to router events first, then update selectedIndex
    // NavigationEnd will fire on initial load, so we don't need to call it directly
    this.router.events.subscribe((event: any): void => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          this.autocloseOverlaysService.trigger();
        }
      }
      // Update selectedIndex when navigation ends (URL has changed)
      // This also fires on initial page load
      if (event instanceof NavigationEnd) {
        this.updateSelectedIndexFromRoute();
        
        // Cookie banner auto-dismiss logic
        // if (!this.initialUrl) {
        //   this.initialUrl = event.urlAfterRedirects;
        // } else if (this.initialUrl !== event.urlAfterRedirects && this.showCookieBanner) {
        //   this.dismissCookieBanner();
        // }
        if (this.showCookieBanner && this.cookieAutoDismissReady) {
          const currentUrl = event.urlAfterRedirects.split('?')[0];
          if (currentUrl !== this.cookieEntryUrl) {
            this.dismissCookieBanner();
          }
        }
      }
    });

    // Event For Menu  
    this.events.subscribe('loginn', (data: any) => {
      console.log("login event call")
      if (data.login == true) {
        console.log("login event call true")
        this.isLogin = true;
        this.detectChange.detectChanges();

        this.checkUnreadChatCount();
        this.startAccountNoticeSubscription();

        // Update selectedIndex after login status changes
        // Use a longer delay to ensure route is stable after login
        setTimeout(() => {
          this.updateSelectedIndexFromRoute();
        }, 200);

        // // ADD THIS: Handle pending deeplink after login
        // setTimeout(() => {
        //   const pendingDeeplink = this.getPendingDeeplink();
        //   if (pendingDeeplink) {
        //     console.log('User logged in - navigating to pending deeplink:', pendingDeeplink);
        //     this.router.navigateByUrl(pendingDeeplink);
        //   }
        // }, 1000); // Small delay to ensure login is complete
      } else {
        console.log("login event call false")
        this.isLogin = false;
        this.unreadCountChecked = false;
        this.stopAccountNoticeSubscription();
        this.dismissAccountNoticeModal();
        this.detectChange.detectChanges();
        
        // Update selectedIndex after logout
        // Use a longer delay to ensure route is stable after logout
        setTimeout(() => {
          this.updateSelectedIndexFromRoute();
        }, 200);
      }
    });

    if (Capacitor.getPlatform() !== "web") {
      console.log(this.screenOrientation.type);
      if (this.platform.is('tablet')) {
        this.screenOrientation.unlock();
      } else {
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY);
      }
    }
  }

  requestNotificationPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
        } else {
          console.log('Notification permission denied.');
        }
      });
    } else {
      console.log('This browser does not support notifications.');
    }
  }

  async goLogin() {
    this.menuCtrl.close();
    const modal = await this.modalController.create({
      component: LoginPage,
      cssClass: 'modal_login',
      backdropDismiss: false,
      componentProps: {
        source: null
      }
    });
    return await modal.present();
  }

  async goSignup() {
    this.menuCtrl.close();
    const modal = await this.modalController.create({
      component: SignupPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  async pricing() {
    this.menuCtrl.close();
    const modal = await this.modalController.create({
      component: PricingPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  goToTerms() {
    // this.menuCtrl.close();
    this.router.navigate(['/terms-of-service']);
  }
 
  goToPrivacy() {
    // this.menuCtrl.close();
    // this.router.navigate(['/privacy-policy']);
    this.router.navigate(['/privacy-policy']);
  }

  dismissCookieBanner() {
    this.showCookieBanner = false;
    localStorage.setItem('cookieBannerDismissed', 'true');
  }

  async logout() {
    this.menuCtrl.close();
    await this.push.unregister(); // needs the session, so before it is cleared
    this.analytics.reset();
    localStorage.clear();
    await this.store.dispatch(setLocation(null));
    await this.store.dispatch(setSelectedLocation(null));
    await this.store.dispatch(setLocationID(null));
    await this.store.dispatch(setAlredyHaveLocation(null));
    await this.store.dispatch(setAddressType(null));
    await this.store.dispatch(setAuthentication(null));
    await this.store.dispatch(setNavigationParameter(null));
    await this.store.dispatch(setUser(null));
    await this.store.dispatch(setTradeData(null));
    await this.store.dispatch(setIsChangeTrade(false));
    await this.store.dispatch(setSelectedTrade(null));
    await this.store.dispatch(setPunchItem(null));
    await this.store.dispatch(setPunchItemLocation(null));
    await this.store.dispatch(setSelectedLocationPunchItems(null));
    await this.store.dispatch(setActivityFilters(null));
    await this.store.dispatch(setActivityScheduledFilters(null));
    await this.store.dispatch(setJobsiteFilters(null));
    await this.store.dispatch(setRoomData(null));
    await this.store.dispatch(setIsChangeRoom(false));
    await this.store.dispatch(setActiveLocations(null));
    await this.store.dispatch(setActiveLocationsLastupdate(null));
    await this.store.dispatch(setAllUserLocation(null));
    await this.store.dispatch(setDescriptionData(null));
    await this.store.dispatch(setImportantDateDescription(null));
    await this.store.dispatch(setDevelopmentData(null));
    await this.store.dispatch(setTreeDetail(null));
    await this.store.dispatch(setPunchItemsStore(null))
    await this.store.dispatch(setUserLocalDataUpdate(null))
    await this.store.dispatch(setExpandsPlans(null))
    await this.store.dispatch(setPreviouslyUsedContacts(null))
    await this.store.dispatch(setLastContactFetch(null));
    await this.store.dispatch(setPlanDetail(null));
    await this.store.dispatch(setLocationJobsiteContacts(null));
    await this.store.dispatch(setLocationaImportantDates(null));
    await this.store.dispatch(setAlertsLocations(null));
    await this.store.dispatch(setScheduledLocations(null));
    await this.store.dispatch(setAlertsActiveLocationsLastupdate(null));
    await this.store.dispatch(resetCoachMarks());
    await this.store.dispatch(resetEncouragement());
    this.coachMarkService.resetState();

    this.events.publish('loginn', {
      login: false,
    });
    this.navCtrl.navigateRoot(['/home']);
  }

  openPages(p) {
    this.selectedIndex = 7;
    this.titls = p;

    if(p == 'FAQ'){
      this.router.navigate(['/faq'])
    } else if (p == 'Contacts') {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          fromWhere: "webContacts"
        }
      };
      this.router.navigate(['/tabs/profile-new'], navigationExtras);
      // this.router.navigate(['/contact-list'])
      // this.router.navigate(['/tabs/jobsites'])
    } else if (p == 'terms') {
      this.router.navigate(['/terms-of-service']);
      console.log("terms");
    } else if (p == 'privacy') {
      this.router.navigate(['/privacy-policy']);
      console.log("privacy");
    }
  }

  addSelectedIndex(i) {
    this.selectedIndex = i;
    this.titls = '';

    const p = this.appPagesLogin[i];
    if (!p?.url) {
      return;
    }

    if (p.url === '/tabs/chat') {
      let locationId: string | null = null;
      const segments = this.router.url.split('?')[0].split('/').filter(Boolean);

      for (const route of ['active-punch-details', 'active-punch-trade-details']) {
        const idx = segments.indexOf(route);
        if (idx !== -1 && segments[idx + 1]) {
          locationId = decodeURIComponent(segments[idx + 1]);
          break;
        }
      }

      console.log(locationId,"locationId");
      if (locationId) {
        this.router.navigate(['/tabs/chat'], { queryParams: { locationId } });
      } else {
        this.router.navigate(['/tabs/chat']);
      }
      return;
    }

    console.log(p.url,"p.url");
    this.router.navigate([p.url]);
  }

  async openMoreInfo() {
    const modal = await this.modalController.create({
      component: AddPunchitemSameLocationPage,
      cssClass: 'modal_all',
      backdropDismiss: false
    });

    modal.onDidDismiss().then(async (data) => {
      console.log(data,"daataatatta", this.locationData);

      let currentLocation = this.locationData

      if(data?.data == 'yes'){
        if(this.locationData?.primary_supervisor_user?.id != this.userData?.user?.id){
          if(this.locationData?.street_address != '' && this.locationData?.unit != ''){
            // For Both
            this.createLocation('both')
          }else if(this.locationData?.street_address != '' && this.locationData?.unit == ''){
            // Street Address
            this.createLocation('streetAddress')
          }else if(this.locationData?.unit != '' && this.locationData?.street_address == '' ){
            // manual
            this.createLocation('manual')
          }
        }else{
          this.allDispatchForLocation(currentLocation);
        }
      } else if (data?.data == 'no') {
        this.router.navigate(['/tabs/create-punchlist']);
      }
    });

    return await modal.present();
  }

  capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  async createLocation(forWhat) {
    let data = {};
    if(forWhat == 'manual'){
      data = {
        development_site: this.capitalizeName(this.locationData?.development_site),
        location_type: forWhat,
        street_address: "",
        unit: this.locationData?.unit + "",
        status: "status#draft",
        GSI2SK : this.locationData?.unit + " " + this.capitalizeName(this.locationData?.development_site),
        primary_super_contact: this.userData?.user?.email,
        display_name: this.userData?.user?.fullname
      }

      let checkData = {
        location: this.locationData?.unit + " " + this.capitalizeName(this.locationData?.development_site),
      }
      this.common.callApi(
        this.constant.LOCATION_CHECK,
        checkData,
        'POST',
        '',
        false,
        false,
        true
      ).subscribe(async (results: any) => {
        console.log("Check For location!", results);
        
        if(results?.length <= 0){
          this.common.callApi(
            this.constant.CREATE_LOCATION_V2,
            data,
            'POST',
            '',
            false,
            false,
            true
          ).subscribe(async (results: any) => {
            console.log("Created Successfully from app component!", results);
            this.allDispatchForCreatedLocation(results);
          }, (err) => {
            console.log(err);
          })
        }else{

          await this.store.dispatch(setLocationID(results?.location_check[0].id));
          await this.store.dispatch(setAlredyHaveLocation('yes'));

          let selected = {
            unumber: results?.location_check[0]?.unit,
            development: results?.location_check[0]?.development_site,
            address: results?.location_check[0]?.street_address,
            location_status: results?.location_check[0]?.location_status,
            primary_supervisor: results?.location_check[0]?.primary_supervisor
          }
          await this.store.dispatch(setSelectedLocation(selected));
          await this.store.dispatch(setAddressType(results?.location_check[0]?.location_type));
          let navigationExtras: NavigationExtras = {
            queryParams: {
              fromWhere: "createPunchList",
            }
          }
          this.router.navigate(['/punch-list-items'], navigationExtras);

          // this.allDispatchForLocation();
        }

      }, (err) => {
        console.log(err);
      })

    }else if(forWhat == 'streetAddress'){
      data = {
        development_site: "",
        location_type: forWhat,
        street_address: this.locationData?.street_address,
        unit: "",
        status: "status#draft",
        GSI2SK : this.locationData?.street_address,
        primary_super_contact: this.userData?.user?.email,
        display_name: this.userData?.user?.fullname
      }

      let checkData = {
        location: this.locationData?.street_address,
      }
      this.common.callApi(
        this.constant.LOCATION_CHECK,
        checkData,
        'POST',
        '',
        false,
        false,
        true
      ).subscribe(async (results: any) => {
        console.log("Check For location!", results);
        
        if(results?.length <= 0){
          this.common.callApi(
            this.constant.CREATE_LOCATION_V2,
            data,
            'POST',
            '',
            false,
            false,
            true
          ).subscribe(async (results: any) => {
            console.log("Created Successfully from app component!", results);
            this.allDispatchForCreatedLocation(results);
          }, (err) => {
            console.log(err);
          })
        }else{
          await this.store.dispatch(setLocationID(results?.location_check[0].id));
          await this.store.dispatch(setAlredyHaveLocation('yes'));

          let selected = {
            unumber: results?.location_check[0]?.unit,
            development: results?.location_check[0]?.development_site,
            address: results?.location_check[0]?.street_address,
            location_status: results?.location_check[0]?.location_status,
            primary_supervisor: results?.location_check[0]?.primary_supervisor
          }
          await this.store.dispatch(setSelectedLocation(selected));
          await this.store.dispatch(setAddressType(results?.location_check[0]?.location_type));
          let navigationExtras: NavigationExtras = {
            queryParams: {
              fromWhere: "createPunchList",
            }
          }
          this.router.navigate(['/punch-list-items'], navigationExtras);
        }

      }, (err) => {
        console.log(err);
      })
    }else if(forWhat == 'both'){
      data = {
        development_site: this.capitalizeName(this.locationData?.development_site),
        location_type: forWhat,
        street_address: this.locationData?.street_address,
        unit: this.locationData?.unit + "",
        status: "status#draft",
        GSI2SK : this.locationData?.street_address,
        primary_super_contact: this.userData?.user?.email,
        display_name: this.userData?.user?.fullname
      }

      let checkData = {
        location: this.locationData?.street_address,
      }
      this.common.callApi(
        this.constant.LOCATION_CHECK,
        checkData,
        'POST',
        '',
        false,
        false,
        true
      ).subscribe(async (results: any) => {
        console.log("Check For location!", results);
        
        if(results?.length <= 0){
          this.common.callApi(
            this.constant.CREATE_LOCATION_V2,
            data,
            'POST',
            '',
            false,
            false,
            true
          ).subscribe(async (results: any) => {
            console.log("Created Successfully from app component!", results);
            this.allDispatchForCreatedLocation(results);
          }, (err) => {
            console.log(err);
          })
        }else{
          await this.store.dispatch(setLocationID(results?.location_check[0].id));
          await this.store.dispatch(setAlredyHaveLocation('yes'));

          let selected = {
            unumber: results?.location_check[0]?.unit,
            development: results?.location_check[0]?.development_site,
            address: results?.location_check[0]?.street_address,
            location_status: results?.location_check[0]?.location_status,
            primary_supervisor: results?.location_check[0]?.primary_supervisor
          }
          await this.store.dispatch(setSelectedLocation(selected));
          await this.store.dispatch(setAddressType(results?.location_check[0]?.location_type));
          let navigationExtras: NavigationExtras = {
            queryParams: {
              fromWhere: "createPunchList",
            }
          }
          this.router.navigate(['/punch-list-items'], navigationExtras);
        }

      }, (err) => {
        console.log(err);
      })
    }
  }

  async allDispatchForLocation(locationData){
    // await this.store.dispatch(setLocationID(this.locationData.locationId));
    // await this.store.dispatch(setAlredyHaveLocation('yes'));

    // let selected = {
    //   unumber: this.locationData?.unit,
    //   development: this.locationData?.development_site,
    //   address: this.locationData?.street_address,
    //   location_status: this.locationData?.location_status,
    //   primary_supervisor: this.locationData?.primary_supervisor,
    // }

    // console.log("Ahiya Avyuuuuu", this.locationData)


    // await this.store.dispatch(setSelectedLocation(selected));
    // let typee = (this.locationData?.street_address != '' && this.locationData?.unit != '') ? "both" : (this.locationData?.street_address != '' && this.locationData?.unit != '') ? "streetAddress" : "manual"
    // await this.store.dispatch(setAddressType(typee));
    // let navigationExtras: NavigationExtras = {
    //   queryParams: {
    //     fromWhere: "createPunchList",
    //   }
    // }
    // this.router.navigate(['/punch-list-items'], navigationExtras);

    await this.store.dispatch(setLocationID(locationData.locationId));
    await this.store.dispatch(setAlredyHaveLocation('yes'));

    let selected = {
      unumber: locationData?.unit,
      development: locationData?.development_site,
      address: locationData?.street_address,
      location_status: locationData?.location_status,
      primary_supervisor: locationData?.primary_supervisor,
    }

    console.log("Ahiya Avyuuuuu", locationData)


    await this.store.dispatch(setSelectedLocation(selected));
    let typee = (locationData?.street_address != '' && locationData?.unit != '') ? "both" : (locationData?.street_address != '' && locationData?.unit != '') ? "streetAddress" : "manual"
    await this.store.dispatch(setAddressType(typee));
    let navigationExtras: NavigationExtras = {
      queryParams: {
        fromWhere: "createPunchList",
      }
    }
    this.router.navigate(['/punch-list-items'], navigationExtras);
  }

  async allDispatchForCreatedLocation(results){
    this.util.presentToast("Jobsite added - let's add punch items");
    await this.store.dispatch(setLocationID(results?.location?.id));
    await this.store.dispatch(setAlredyHaveLocation('yes'));

    let selected = {
      unumber: results?.location?.unit,
      development: results?.location?.development_site,
      address: results?.location?.street_address,
      location_status: this.locationData?.location_status,
      primary_supervisor: this.locationData?.primary_supervisor
    }
    await this.store.dispatch(setSelectedLocation(selected));
    let typee = (results?.location?.street_address != '' && results?.location?.unit != '') ? "both" : (results?.location?.street_address != '' && results?.location?.unit != '') ? "streetAddress" : "manual"
    await this.store.dispatch(setAddressType(typee));
    let navigationExtras: NavigationExtras = {
      queryParams: {
        fromWhere: "createPunchList",
      }
    }
    this.router.navigate(['/punch-list-items'], navigationExtras);
  }

  // async newPunchList() {
    
  //   var n = this.router.url.lastIndexOf('/');
  //   var result = this.router.url.substring(n + 1);

  //   this.store.select<any>('punchItemData').subscribe(state => this.punchItemData = state);
  //   this.locationData = this.punchItemData.selectedPunchItemLocation;
  
  //   console.log(result,"result",this.locationData);

  //   if(result == 'active-punch-details'){
  //     this.openMoreInfo();
  //   }else if(result == 'active-punch-item-details'){
  //     this.openMoreInfo();
  //   }else if(result.includes('active-punch-trade-details')) {
  //     this.openMoreInfo();
  //   }else{
  //     this.router.navigate(['/tabs/create-punchlist']);
  //   }

  // }


  checkSubscription() {
    console.log(this.userData, "USER DATA")
    this.common.callApi(
      this.constant.CHECK_USER_SUBSCRIPTION_STATUS+this.userData?.user?.userID,
      '',
      'GET',
      '',
      false,
      false,
      true
    ).subscribe(async (results: any) => {
      console.log(results, "=====")
      if(results?.user_item?.length == 0) {
        console.log(results , "Error");
        this.subscriptionError();
      } else {
        let status = results.user_item[0]?.sub_status
        if(status == 'Free Trial' || status == 'Free' || status == 'Professional'|| status == 'Premium') {
          // this.newPunchList();
          // var n = this.router.url.lastIndexOf('/');
          // var result = this.router.url.substring(n + 1);
          const urlSegments = this.router.url.split('/').filter(segment => segment !== '');

          let result = '';
          
          const tabsIndex = urlSegments.indexOf('tabs');
          const jobsitesIndex = urlSegments.indexOf('jobsites');
        
          if (tabsIndex !== -1 && jobsitesIndex !== -1 && urlSegments.length > jobsitesIndex + 1) {
            // If both 'tabs' and 'jobsites' exist, pick the next segment after 'jobsites'
            result = urlSegments[jobsitesIndex + 1];
          } else if (tabsIndex !== -1 && urlSegments.length > tabsIndex + 1) {
            // If only 'tabs' exists, pick the next segment
            result = urlSegments[tabsIndex + 1];
          } else if (urlSegments.length > 0) {
            // If neither 'tabs' nor 'jobsites' exist, take the first segment
            result = urlSegments[0];
          }
          
          console.log(this.router.url,":::::::::::::::::::::::",result);
      
          this.store.select<any>('punchItemData').subscribe(state => this.punchItemData = state);
          this.locationData = this.punchItemData.selectedPunchItemLocation;
        
          console.log(result,"result",this.locationData);
      
          if(result == 'active-punch-details'){
            this.openMoreInfo();
          }else if(result == 'active-punch-item-details'){
            this.openMoreInfo();
          }else if(result.includes('active-punch-trade-details')) {
            this.openMoreInfo();
          }else{
            this.router.navigate(['/tabs/create-punchlist']);
          }  
        } else {
          this.subscriptionError();
        }
      }
    }, (err) => {
      
      console.log("error in get tags!", err);
    })
  }

  async subscriptionError() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      // header: 'Are you sure?',
      message: 'No subscription found',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }
      ]
    });
    await alert.present();
  }

  readDataFromUserLocalDataTable() {
    this.store.select<any>('punchItemData').subscribe(state => this.punchItemData = state);
    this.store.select<any>('locationData').subscribe(state => this.locationData = state);
    console.log("LOCATION DATA = ", this.locationData)
    let fetchTime = this.locationData?.userLocalDataUpdate; 
    if(fetchTime == null || fetchTime == undefined) {
      fetchTime = Date.now();
    } else {
      fetchTime = this.locationData?.userLocalDataUpdate
    }

    console.log(this.punchItemData?.punchItemsStore, "PUNCH ITEMS STORE");
    let body = { 
      "lastFetch": this.locationData?.userLocalDataUpdate ? this.locationData?.userLocalDataUpdate+"" : Date.now()+"",
      // "lastFetch": "1682160196",
      
    }

    this.common.callApi(
      this.constant.GET_USERLOCALDATA_TABLE_LASTREAD,
      body,
      'POST',
      '',
      false,
      false,
      true
    ).subscribe((results: any) => {
      console.log("READ LOCAL DATA === ", results.data, Date.now());
      this.store.dispatch(setUserLocalDataUpdate(Date.now()))

      // let newData = this.punchItemData?.punchItemsStore;
      let newData = this.punchItemData?.punchItemsStore?.map(obj => ({...obj}))
      console.log(newData, "NEW DATA")
       newData?.forEach((element, index) => {
        
        // const filteredLocArray = results.data.filter(obj => obj.sk == element.locationId);
        const filteredLocArray = results.data.filter(obj => obj.sk?.includes(element.locationId));
        console.log(filteredLocArray,"filteredLocArray filteredLocArray filteredLocArray filteredLocArray");
        
        if(filteredLocArray?.length > 0) {
          console.log("LOCATION CHANGE",filteredLocArray)
          // element.lastPunchItemsFetch = filteredLocArray[0]?.GSI1SK;
          // element.lastPunchItemsFetch = filteredLocArray[0]?.lastPunchItemsFetch;

          filteredLocArray?.forEach((elem) => {
            console.log(element,"[][filteredLocArray][][[][filteredLocArray][][filteredLocArray][][][[][][]");
            
            if(elem?.sk.includes("lastPunchItemsFetch")){
              console.log(elem,"elem.includes(lastPunchItemsFetch) elem.includes(lastPunchItemsFetch) elem.includes(lastPunchItemsFetch) ");
              
              element.lastPunchItemsFetch = elem?.lastPunchItemsFetch;
            }
            if(elem?.sk.includes("lastProgressUpdate")){

              console.log(elem,"elem.includes(lastProgressUpdate) elem.includes(lastProgressUpdate) elem.includes(lastProgressUpdate) ");
              element.lastProgressUpdate = elem?.lastProgressUpdate;
            }
          })
        }
        element?.punchItems?.forEach((ele, i) => {
          // const filteredArray = results.data.filter(obj => obj.sk == ele.id);
          const filteredArray = results.data.filter(obj => obj.sk?.includes(ele.id));
          if(filteredArray?.length > 0) {
            const newPunchItems = [...element.punchItems];
            newPunchItems[i] = { 
              ...ele, 
              // lastRead: filteredArray[0].GSI1SK,
              lastRead: filteredArray[0].lastRead,
              lastRoomOpen: filteredArray[0].lastRoomOpen,
              hasPunchItemComment: false,
              hasTradeComment: false
            };
            element.punchItems = newPunchItems;
            console.log(newPunchItems[i], "ELELELELE")
          }
        });
        if((newData?.length - 1) == index) {
          console.log(newData, "FINAL =====");
          this.store.dispatch(setPunchItemsStore(newData))
        }
      });
    }, (err) => {
      console.log(err);
    })
  }

  getPreviousContact() {

    this.store.select<any>('locationData').subscribe(state => this.locationData = state);

    this.lastContactFetch = this.locationData.lastContactFetch;

    let previousContact = this.locationData?.previouslyUsedContacts == null ? [] : this.locationData?.previouslyUsedContacts;
    console.log(previousContact, "PREV PREV PREV PREV PREV")
    
    let currentTimestamp = Date.now();
    
    let body = {
      lastContactFetch: this.lastContactFetch != null ? this.lastContactFetch : undefined,
      currentTimestamp: currentTimestamp+""
    }

    this.common.callApi(
      this.constant.GET_PREVIOUS_USED_CONTACTS_V2,
      body,
      'POST',
      '',
      false,
      false,
      true
    ).subscribe(async (results: any) => {
      console.log("Previously Used Contact", results.contacts);
      
      // await this.store.dispatch(setLastContactFetch(Date.now()+""));

      // await this.store.dispatch(setLastContactFetch("1690958159910"));

      if(previousContact == null || previousContact == undefined || previousContact?.length == 0) {
        previousContact = [];
      }

      // let prevContact = this.previousContact.concat(results.contacts);

      let prevContact = results.contacts.concat(previousContact);

      console.log(prevContact, "PREV CONTACTTT")


      const filteredArray = prevContact.filter((obj, index, self) => {
        return index == self.findIndex((o) => o.sk == obj.sk);
      });

      previousContact = filteredArray;

      console.log(previousContact, "After Concatnation");

      await this.store.dispatch(setLastContactFetch(Date.now() + ""));
      this.dynamicObjectGenerationForPrevious(previousContact);
      // this.getChangedOwner(previousContact, body)
      
      // this.dynamicObjectGenerationForPrevious(previousContact);
    }, (err) => {
      console.log("error in Previously Used Contact", err);
    })
  }

  getChangedOwner(previousCont, body) {

    this.common.callApi(
      this.constant.GET_CHANGED_OWNER,
      body,
      'POST',
      '',
      false,
      false,
      true
    ).subscribe(async (results: any) => {
      console.log("Get Owner", results.contacts);

      await this.store.dispatch(setLastContactFetch(Date.now()+""));

      // await this.store.dispatch(setLastContactFetch("1690958159910"));

      console.log(previousCont, results.contacts, "===============")

      let allPrev = [];
      previousCont?.forEach((ele) => {
        
        let newData = results.contacts?.filter((x) => x.oldUserId == ele.sk);
        console.log(newData, "NEW DATTTT")
        if(newData?.length > 0) {
          let obj = {
              ...ele,
              GSI1SK: newData[0]?.sk,
              GSI2PK: newData[0]?.newUserId,
              lastUpdate: newData[0]?.sk,
              sk: newData[0]?.newUserId
          }
          allPrev.push(obj);
        } else {
          allPrev.push(ele)
        }
      })

      console.log(allPrev, "ALL PREV PUSH DATA");

      const filteredPreviousCont = previousCont?.filter((ele) => {
        return !results.contacts?.some((x) => x.oldUserId === ele.sk);
      });
        
      console.log(filteredPreviousCont, "FINALLLLL");

      this.dynamicObjectGenerationForPrevious(filteredPreviousCont);

      // await this.store.dispatch(setLastContactFetch(Date.now()+""));


      

    }, (err) => {
      console.log("error in Previously Used Contact", err);
    })
  }

  dynamicObjectGenerationForPrevious(previousContact) {
    console.log("=======DYNAMIC", previousContact);
    this.store.dispatch(setPreviouslyUsedContacts(previousContact));

    const updatedPreviousContact = previousContact.map(element => {
      const clonedElement = { ...element };
      clonedElement.displayNameLocal = clonedElement.displayName;
      clonedElement.grantSupervisour = clonedElement.is_supervisor;
      return clonedElement;
    });
    
    previousContact = updatedPreviousContact;
    console.log(previousContact, "PREVVVVV");

  }

}
